import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cab4ce0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Edit Page ")
  ])
], -1))
const _hoisted_4 = { class: "col-md-7 text-start" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, null, -1))
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Title", -1))
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Slug", -1))
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Detail", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.title) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Title",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.slug) = $event)),
              class: "form-control",
              placeholder: "Slug",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.slug]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_QuillEditor, {
              ref: "contentdata",
              theme: "snow",
              toolbar: "full",
              content: $setup.data.detail,
              "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.detail) = $event)),
              "content-type": "html",
              output: "html"
            }, null, 8, ["content"])
          ]),
          _hoisted_12
        ], 32)
      ])
    ])
  ]))
}